import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { QuillEditor } from "sj-ui-toolkit/src/components/QuillEditor/QuillEditor";

interface NoteDialogProps {
  visible: boolean;
  onHide: () => void;
  onSubmit: (noteText: string) => Promise<void>;
}

export const NoteDialog = ({ visible, onHide, onSubmit }: NoteDialogProps) => {
  const [noteText, setNoteText] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!visible) {
      setNoteText("");
    }
  }, [visible]);

  const isEmpty = !noteText.trim() || noteText === "<p><br></p>";

  const handleSubmit = async () => {
    if (isEmpty) return;
    try {
      setSubmitting(true);
      await onSubmit(noteText);
      setNoteText("");
    } catch (err) {
      console.error("Failed to add note:", err);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    setNoteText("");
    onHide();
  };

  return (
    <Dialog
      header="Add Note"
      visible={visible}
      onHide={handleCancel}
      style={{ width: "700px" }}
      footer={
        <div>
          <Button
            label="Cancel"
            icon="pi pi-times"
            onClick={handleCancel}
            severity="secondary"
            text
            disabled={submitting}
          />
          <Button
            label="Save Note"
            icon="pi pi-check"
            onClick={() => void handleSubmit()}
            loading={submitting}
            disabled={submitting || isEmpty}
          />
        </div>
      }
    >
      <QuillEditor value={noteText} onChange={setNoteText} placeholder="Write your note here..." />
    </Dialog>
  );
};
